import React from 'react';
import '../styles/Layout.css';


const Footer = () => (
  <footer className="footer">
    <div className="layout-container" style={{ padding: '56px 40px 28px' }}>
      <div className="footer-grid">
        {/* Brand Column */}
        <div className="footer-brand">
          <div className="footer-logo">AEC<span className="highlight">Block</span></div>
          <p className="footer-tagline">Transformando la construcción con tecnología. El marketplace hecho por y para Arquitectos, Ingenieros y Constructores de Latinoamérica.</p>
          <div className="footer-social">
            <a
              href="https://www.instagram.com/aecblock"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
              title="Instagram"
            >
              ig
            </a>
            <a
              href="https://www.facebook.com/people/Aecblock/61587159102863/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Facebook"
              title="Facebook"
            >
              fb
            </a>
            <a
              href="https://www.linkedin.com/company/aecblock/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              in
            </a>
             <a
               href="https://wa.me/593999527013"
               target="_blank"
               rel="noopener noreferrer"
               className="social-icon"
               aria-label="WhatsApp"
               title="WhatsApp"
               style={{ color: '#25D366', borderColor: 'rgba(37, 211, 102, 0.3)' }}
             >
               ws
             </a>
          </div>
        </div>

        {/* Explorar Column */}
        <div>
          <div className="footer-col-title">Explorar</div>
          <a href="/catalog" className="footer-link">Catálogo</a>
          <a href="/catalog" className="footer-link">Nuevos Lanzamientos</a>
          <a href="/catalog" className="footer-link">Más Populares</a>
          <a href="/catalog" className="footer-link">Herramientas Gratuitas</a>
        </div>

        {/* Compañía Column */}
        <div>
          <div className="footer-col-title">Compañía</div>
          <a href="/nosotros" className="footer-link">Sobre Nosotros</a>
          <a href="/contacto" className="footer-link">Contacto</a>
          <a href="/solicitudCreador" className="footer-link">Vende con Nosotros</a>
        </div>

        {/* Legal Column */}
        <div>
          <div className="footer-col-title">Legal</div>
          <a href="/terminos" className="footer-link">Términos y Condiciones</a>
          <a href="/privacy-policy" className="footer-link">Política de Privacidad</a>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <span className="footer-copy">© 2026 AECBlock. Todos los derechos reservados.</span>
        <span className="footer-copy">Hecho con ❤️ en Latinoamérica</span>
      </div>
    </div>
  </footer>
);

export default Footer;
